import React, { FC, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { Form } from '../components/shipping-address-form/Form';
import { useShippingAddress } from '../hooks/use-shipping-address';
import { ShippingAddressViewType } from '../types/view/shipping-address-view-type';

export const ShippingAddressForm: FC<{ setting: Setting }> = ({ setting }) => {
  const history = useHistory();
  const [subscriptionContractId, setSubscriptionContractId] = useState('');
  const [shippingAddress, setShippingAddress] = useState<ShippingAddressViewType>();

  const { updateShippingAddress } = useShippingAddress(setting, setSubscriptionContractId, setShippingAddress);

  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setting.resize(root.current?.clientHeight ?? 0);
  }, [setting, root.current?.clientHeight, shippingAddress]);

  return (
    <div className={classes.mypage_subsc_container} ref={root}>
      <Form
        shippingAddress={shippingAddress}
        changeFunc={(key, value) => {
          setShippingAddress({
            ...shippingAddress!,
            [key]: value,
          });
        }}
        submitFunc={() => {
          updateShippingAddress(
            subscriptionContractId,
            shippingAddress!,
            () => {
              history.push('/shipping-address');
            },
            (message) => console.log(message)
          );
        }}
      />
    </div>
  );
};
